import React from 'react'
const BackStackContext = React.createContext<string[]>([])
export default BackStackContext
